export const useFeature = (...args: string[]): boolean[] => {
  return args.map(() => false);
};
